"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaName = schemaName;
function schemaName(schema) {
    return schema.shortName || schema.alias || schema.name;
}
//# sourceMappingURL=schema-name.js.map